/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface KeywordWithOrigin
 */
export interface KeywordWithOrigin {
    /**
     * 
     * @type {string}
     * @memberof KeywordWithOrigin
     */
    value: string;
    /**
     * 
     * @type {Origin}
     * @memberof KeywordWithOrigin
     */
    origin: Origin;
}

/**
 * Check if a given object implements the KeywordWithOrigin interface.
 */
export function instanceOfKeywordWithOrigin(value: object): value is KeywordWithOrigin {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function KeywordWithOriginFromJSON(json: any): KeywordWithOrigin {
    return KeywordWithOriginFromJSONTyped(json, false);
}

export function KeywordWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): KeywordWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function KeywordWithOriginToJSON(value?: KeywordWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'origin': OriginToJSON(value['origin']),
    };
}

